import {
  OwnedMdIcon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@crono-one/design-system';
import { TeamsUsersSelect } from 'components/TeamsUsersSelect';
import { useAuth } from 'context/auth';
import { fullName } from 'crono-fe-common/utils';

export interface OwnerPickerProps {
  /** Disables the picker and explains it on hover. */
  lockedReason?: string | null;
  ownerId: number | undefined;
  onChange: (ownerId: number | undefined) => void;
}

/** Owner picker of a creation form. */
const OwnerPicker = ({ lockedReason, ownerId, onChange }: OwnerPickerProps) => {
  const { user } = useAuth();
  // The users list is paginated, so the current user's name is passed along in
  // case they aren't on the first page.
  const ownerName =
    ownerId !== undefined && ownerId === user?.id
      ? fullName(user.firstName, user.lastName)
      : undefined;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* The reason hangs off a wrapper: the picker renders no element of its own to anchor it. */}
        <div>
          <TeamsUsersSelect
            placeholder="Select owner"
            selectedUserName={ownerName}
            selectedUsersIds={ownerId}
            onChangeSelectedUsersIds={onChange}
            disabled={!!lockedReason}
            size="sm"
            triggerIcon={<OwnedMdIcon className="size-6 shrink-0" />}
            triggerClassName="gap-2 border-neutral-300 pl-1"
            forceTriggerWidth
          />
        </div>
      </TooltipTrigger>
      {lockedReason && <TooltipContent>{lockedReason}</TooltipContent>}
    </Tooltip>
  );
};

export default OwnerPicker;
